window.addEventListener('DOMContentLoaded', () => {

    // default
    let search_open = false;
    let open_search_button = document.getElementById('show-search');
    let search_lightbox = document.getElementById('search-lightbox');

    open_search_button.addEventListener( 'click', toggle_search_lightbox );
    search_lightbox.addEventListener( 'click', toggle_search_lightbox );

    function toggle_search_lightbox(e){

        e.preventDefault();
        e.stopPropagation();

        if( false == search_open ){
            search_lightbox.style.display = "block";
            setTimeout( () => search_lightbox.style.opacity = 1 , 100);
            window.addEventListener('keydown', handle_keypress );
        }
        
        if( true == search_open && e.target.id == "search-lightbox" ){
            search_lightbox.style.opacity = 0;
            setTimeout( () => search_lightbox.style.display = "none" , 600);
            window.removeEventListener( 'keydown', handle_keypress );
        }

        search_open = !search_open;

    }

    function handle_keypress(e){
        if( "Escape" == e.key ){
            // close search
            search_lightbox.style.opacity = 0;
            setTimeout( () => search_lightbox.style.display = "none" , 600);
            window.removeEventListener( 'keydown', handle_keypress )
            search_open = false;
        }
    }

});